<template>
  <div>
    <el-tabs>
      <el-tab-pane
        v-for="(tab, i) in tabsFieldsSchema"
        :label="tab.label"
        :key="i"
      >
        <component-compiler
          v-for="(component, x) in tab.fields"
          :content="component"
          :key="x"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import ComponentCompiler from '@/components/ComponentCompiler'
import fields from '@/components/fields/'

export default {
  components: {
    ComponentCompiler
  },
  props: ['form', 'errors'],
  created() {
    this.fixArrayFields()
  },
  data() {
    return {
      arrayFields: []
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: this.getCommonFields()
        }
      ]
    }
  },
  methods: {
    getCommonFields() {
      return [
        new fields.Input({
          label: 'Indeks',
          modelPath: [this, 'form', 'index'],
          multilingual: true
        }),
        new fields.Input({
          label: 'Nazwa robocza',
          modelPath: [this, 'form', 'working_name']
        }),
        new fields.Switch({
          label: 'Ciemne tło',
          modelPath: [this, 'form', 'is_dark']
        })
      ]
    },
    fixArrayFields() {
      this.arrayFields.forEach(field => {
        if (!Array.isArray(this.form[field])) {
          this.$set(this.form, field, [])
        }
      })
    }
  }
}
</script>
